import { render } from "./ManageStoreSupply.vue?vue&type=template&id=36101356&scoped=true"
import script from "./ManageStoreSupply.vue?vue&type=script&lang=js"
export * from "./ManageStoreSupply.vue?vue&type=script&lang=js"

import "./ManageStoreSupply.vue?vue&type=style&index=0&id=36101356&scoped=true&lang=css"
import "./ManageStoreSupply.vue?vue&type=style&index=1&id=36101356&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36101356"]])

export default __exports__